<template>
<div>
  <div class="d-print-none d-block">
  <div class="row">
    <div class="col">
      <div
        class="container-fluid col-md-11"
        style="
          background: rgb(248, 249, 250);
          border-radius: 10px;
          box-shadow: 5px 5px 5px 5px #999999;
        "
        id="contenedor"
      >
      <u @click="irMenu()">
				<br><h6>Volver</h6>
            </u>
      <div class="d-flex justify-content-center">
							<div class="row">
								<div class="col">
								<br>
								<img src="https://seguimiento.cmimbral.cl/assets/logo_tienda.png"  width="200" class="img-fluid" alt="Responsive image"><br>
								</div>
							</div>
							
                        </div><br>
            <h3 class="text-center"><b>Resumen</b></h3><br>
      <div class="d-flex justify-content-center">
        <div class="row">
          <div class="col">
            
<label>Ver:</label>
                    <select class="form-select" aria-label="Default select example" id="busqueda" @change="cambio()" style="border-color: rgb(237, 126, 37);">
                      <!--<option value="1">Vales por RUT</option>-->
                      <option value="2">Tipo Pago y fecha</option>
                      <option value="4">Desc. Planilla y convenio</option>
                      <option value="3">RUT y fecha</option>
                      
                      <!--<option value="5">Entregas por Usuario</option>
                      <option value="5">Entregas por Hora</option>
                      <option value="4">Razón social y fecha</option>-->
                      </select><br><br>
          </div>
        </div>
        
      </div>
        
							<div id="btipopago" >
							<div class="row">
							<div class="col-sm-4">
                                <div class="form-group">
                                    <label for="comuna" ><strong>Tipo Pago</strong></label>
                                    <select class="form-select" id="tipoPago" aria-label="Default select example"  style="border-color: rgb(237, 126, 37);">
									<option value="Desc. Planilla">Desc. Planilla</option>
                                    <option value="Pago por Caja">Pago por Caja</option>
                                    <option value="Todos">Todos</option>
                                    </select>
                                </div>
                            </div>
							<div class="col-sm-3">
								<label ><strong>Fecha desde</strong></label><br>
								<input type="date" class="form-control" id="fecha1v" style=" border: solid 1px; border-radius: 5px;border-color:rgb(237,126,37) "/>
								
							</div>
                            <div class="col-sm-3">
								<label ><strong>Fecha hasta</strong></label><br>
								<input type="date" class="form-control" id="fecha2v" style=" border: solid 1px; border-radius: 5px; border-color:rgb(237,126,37)"/>
                            </div>
								
								<div class="col-sm"><label for="btnBuscar" ><strong>Buscar</strong></label><br>
										<button type="submit"  id="btnBuscar" class="btn btn-primary" @click="buscarTipoPago()"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37)"><i class="fas fa-search"></i></button>
								</div>
                        </div><br><br>
							
						</div>	

            <div id="brrhh" style="display:none">
							<div class="row">
							<div class="col-sm-3">
                    
                            </div>
							<div class="col-sm-3">
								<label ><strong>Fecha desde</strong></label><br>
								<input type="date" class="form-control" id="fecha1rrhh" style=" border: solid 1px; border-radius: 5px;border-color:rgb(237,126,37) "/>
								
							</div>
                            <div class="col-sm-3">
								<label ><strong>Fecha hasta</strong></label><br>
								<input type="date" class="form-control" id="fecha2rrhh" style=" border: solid 1px; border-radius: 5px; border-color:rgb(237,126,37)"/>
                            </div>
								
								<div class="col-sm"><label for="btnBuscar" ><strong>Buscar</strong></label><br>
										<button type="submit"  id="btnBuscar" class="btn btn-primary" @click="buscarDescuentosPersona()"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37)"><i class="fas fa-search"></i></button>
								</div>
                        </div><br><br>
							
						</div>

            <div id="brut" style="display:none">
							<div class="row">
							<div class="col-sm-4">
                <label ><strong>RUT</strong></label><br>
                                <input type="text" class="form-control "  id="rut" placeholder="Ingrese RUT" required="true"  style="border-color:rgb(237,126,37)"  @keyup="leer()">
                            </div>
							<div class="col-sm-3">
								<label ><strong>Fecha desde</strong></label><br>
								<input type="date" class="form-control" id="fecha1RUT" style=" border: solid 1px; border-radius: 5px;border-color:rgb(237,126,37) "/>
								
							</div>
                <div class="col-sm-3">
								<label ><strong>Fecha hasta</strong></label><br>
								<input type="date" class="form-control" id="fecha2RUT" style=" border: solid 1px; border-radius: 5px; border-color:rgb(237,126,37)"/>
                            </div>
								
								<div class="col-sm"><label for="btnBuscar" ><strong>Buscar</strong></label><br>
										<button type="submit"  id="btnBuscar" class="btn btn-primary" @click="buscarRut()"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37)"><i class="fas fa-search"></i></button>
								</div>
                        </div><br><br>
							
						</div>

            <div id="bdesc" style="display:none">
						</div>
 
        <div id="bDocumento" style="display:none">
        
          <div class="row">
            <div class="col-sm-3"></div>
            <div class="col-sm-5">
              <input type="text" class="form-control form-control-lg"  id="numero" placeholder="Ingrese n° de documento" required="true"  style="border-color:rgb(237,126,37)">
            </div>
            <div class="col-sm">
              <button type="submit"  id="btnBuscar" class="btn btn-primary btn-lg" @click="buscarDocumento()"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37)"><i class="fas fa-search"></i></button>
            </div>
          </div>
        </div><br><br>
  <h3 id="cantidadCheques" style="display:none">Total de vales en la tabla: {{largo}}</h3>
      

<div id="btnExcel1" >
 <div class="d-flex justify-content-center">
        <div class="row">
          <div class="col">
  <export-excel
    class   = "btn btn-default"
    :data   = "Vales"
    :fields = "json_fields"
    worksheet = "Resumen"
    name    = "Resumen Vales Entregados">
 
    <button class="btn btn-success btn-block"  >Generar Excel</button><br><br>
 
</export-excel>
          </div>
        </div>
        
      </div>
</div>

    <div id="btnExcel2" style="display:none">
      <div class="d-flex justify-content-center" >
        <div class="row">
          <div class="col">
  <export-excel
    class   = "btn btn-default"
    :data   = "descuentosxPersona"
    :fields = "json_fieldsDesc"
    worksheet = "Descuentos"
    name    = "Descuentos por Persona">
 
    <button class="btn btn-success btn-block"  >Generar Excel</button><br><br>
 
</export-excel>
          </div>
        </div>
        
      </div></div>
        <table class="table table-striped table-responsive" style="display:block" id="tablaVales">
           <thead style="background-color:rgb(0,58,140);color:white">
            <tr>
              <th>PRODUCTO</th>
              <th>CANTIDAD</th>
              <th>PRECIO</th>
              <th>TOTAL</th>
              <th>COLABORADOR</th>
              <th>FECHA</th>
              <th>TIPO PAGO</th>
              <th>RAZÓN</th>
              <th>USUARIO</th>
              <th>COMPROBANTE</th>
              
              
            
              
            </tr>
          </thead>
          <tbody>
            <tr v-for="x in Vales" :key="x.key">
              <td>{{ x.producto}}</td>
              <td>{{ x.cantidad}}</td>
              <td>{{ x.precio }}</td>
              <td>{{ x.total }}</td>
              <td>{{ x.nombre }}</td>
              <td>{{ x.fecha}} {{ x.hora}}</td>
              <td>{{ x.metodoPago }}</td>
              <td>{{ x.razon }}</td>
              <td>{{ x.usuario }}</td>
              <td v-if="x.comprobante!=null && x.comprobante!='no' && x.metodoPago!='Desc. Planilla'">
                <button
                  type="button"
                  @click="verArchivo(x.comprobante)"
                  class="btn btn-success btn-sm"
                  style="
                    background-color: rgb(0, 56, 143);
                    color: white;
                    border-color: rgb(237, 126, 37);
                  "
                >
                 <i class="far fa-image fa-2x"></i>
                </button>
              </td>
              
              <td v-else>
                <button
                  type="button"
                  @click="imprimirComprobante(x.rut,x.nombre,x.razon,x.convenio,x.total,x.fecha,x.tipo)"
                  class="btn btn-success btn-sm"
                >
                Imprimir
                </button>
              </td>
              
            </tr>
          </tbody>
        </table>
        <table class="table table-striped table-responsive" style="display:none" id="tablaDesc">
           <thead style="background-color:rgb(0,58,140);color:white">
            <tr>
              <th>RUT</th>
              <th>NOMBRE</th>
              <th>SUCURSAL</th>
              <th>AREA</th>
              <th>RAZÓN</th>
              <th>DESCUENTO</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="x in descuentosxPersona" :key="x.key">
              <td>{{ x.rut}}</td>
              <td>{{ x.nombre}}</td>
              <td>{{ x.sucursal }}</td>
              <td>{{ x.area }}</td>
              <td>{{ x.razon }}</td>
              <td>{{ x.descuento }}</td>
              
            </tr>
          </tbody>
        </table>
        <br />
        <iframe id="pdf" width="100%" height="800px"></iframe>
      </div>
    </div>
    <div>

  <b-modal id="modal-1" hide-footer hide-header >
    
    <div class="d-block text-center">
      <h3><b>Editar Cheque</b></h3><br>
      
                <input type="text" id="key" v-model="key" class="form-control" placeholder="Ingrese RUT facturación" style="display:none"  >
                         
                <div class="row">
                
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>RUT facturación</label>
                        <input type="text" id="rutF" v-model="rutFacturacion" class="form-control" placeholder="Ingrese RUT facturación" style="border-color:rgb(237,126,37)"   required>
                         </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>N° documento</label>
                        <input type="text" id="nDoc" v-model="documento" class="form-control" placeholder="Ingrese n° documento" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    
                    
                </div><br>
                
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>RUT titular</label>
                        <input type="text" id="rutT" v-model="rut" class="form-control" placeholder="Ingrese RUT" style="border-color:rgb(237,126,37)" required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>Nombre titular</label>
                        <input type="text" id="nombreT" v-model="nombreTitular" class="form-control" placeholder="Ingrese nombre" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                   
                </div><br>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>Razón social</label>
                        <input type="text" id="razonS" v-model="razonSocial" class="form-control" placeholder="Ingrese nombre" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label>Monto del cheque</label>
                            <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" style="border-color:rgb(237,126,37)">$</span>
                            </div>
                           <input type="text" id="monto" v-model="monto" class="form-control" placeholder="Ingrese monto" style="border-color:rgb(237,126,37)"  required>
                        
                            </div>
                    </div>
                </div><br>
                <div class="row">
                    <div class="form-group">
                        <label for="observacion">Observacion</label>
                        <textarea class="form-control" id="observacion" v-model="observacion" rows="3"  style="border-color:rgb(237,126,37)"></textarea><br>
                    </div>
                </div>
               <!-- <div class="row" >
                    <div class="col-sm-6">
                        <input style="border-color:rgb(237,126,37)" @change="clickImagen($event)" type="file" accept="image/*" >
                    </div>

                </div>--><br>

                
                <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button class="btn btn-primary btn-block" @click="editar()" style="background-color: rgb(0, 56, 143); color: white; border-color: rgb(237, 126, 37);">Editar</button><br><br>
                    </div>
                </div>

    </div>

  </b-modal>
</div>
  </div>





</div>
<div class="d-print-block d-none"><br>
    <div class="d-flex justify-content-center">
							<div class="row">
								<div class="col">
								<br>
								<img src="https://seguimiento.cmimbral.cl/assets/logo_tienda.png"  width="100" class="img-fluid" alt="Responsive image"><br>
								</div>
							</div>
							
                        </div><br>
         <div class="d-flex justify-content-center">
                    <h5><b>Autorización Préstamo Empresa</b></h5><br><br>
        </div>
        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div class="d-flex justify-content-start">
                          <h6>Constancia de Recibo y Autorización:</h6>
                          
        </div>
            </div> <div class="col-sm-1"></div>
        </div>
        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div style="text-align: justify">
                          <h6>En San Javier a {{fechaPrint}}, yo {{nombrePrint}}, Rut: {{rutPrint}} en calidad de trabajador, declaro haber recibido de {{razonPrint}}, quien actúa en calidad de empleador la suma de $ {{montoPrint}}, sin intereses.</h6>
                          
        </div>
            </div> <div class="col-sm-1"></div>
        </div>
        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div style="text-align: justify">
                          <h6>Por lo anterior, autorizo a {{razonPrint}} para que realice descuentos de mis remuneraciones de sueldo.</h6>
                          
        </div>
            </div> <div class="col-sm-1"></div>
        </div>

        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div style="text-align: justify">
                         <h6>
                        -Dicho préstamo será descontado en un total de 1 cuota por un valor de ${{montoPrint}} de las liquidaciones haciendo referencia a {{numeroConvenio}}.
                          </h6>
                          
        </div>
            </div> <div class="col-sm-1"></div>
        </div>

        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div style="text-align: justify">
                         
                          <h6>
                            -Asimismo, si se diera termino al contrato de trabajo de manera anticipada, autorizo expresamente al empleador a descontar de mi Liquidación de Sueldo y/o Finiquito, los valores que correspondan a saldos adeudados de dicho préstamo.
                          </h6>
        </div>
            </div> <div class="col-sm-1"></div>
        </div><br><br><br>
        <div class="row">
            <div class="col-sm-2"></div>
             <div class="col-sm-3">
                <div class="d-flex justify-content-start">
               <span>
                 .......................................<br>
                 <h6>FIRMA EMPLEADOR</h6><br>
               </span>
              </div>    
             </div>
              
            <div class="col-sm-2"></div> 
            
            <div class="col-sm-3">
                <div class="d-flex justify-content-start">
               <span>
                 .......................................<br>
                 <h6>FIRMA TRABAJADOR</h6><br>
               </span>
              </div> 
            </div>
            <div class="col-sm-2"></div>
        </div>
        


    </div>

    <div class="d-print-block d-none"><br><br><br><br>
    <div class="d-flex justify-content-center">
							<div class="row">
								<div class="col">
								<br>
								<img src="https://seguimiento.cmimbral.cl/assets/logo_tienda.png"  width="100" class="img-fluid" alt="Responsive image"><br>
								</div>
							</div>
							
                        </div><br>
         <div class="d-flex justify-content-center">
                    <h5><b>Autorización Préstamo Empresa</b></h5><br><br>
        </div>
        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div class="d-flex justify-content-start">
                          <h6>Constancia de Recibo y Autorización:</h6>
                          
        </div>
            </div> <div class="col-sm-1"></div>
        </div>
        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div style="text-align: justify">
                          <h6>En San Javier a {{fechaPrint}}, yo {{nombrePrint}}, Rut: {{rutPrint}} en calidad de trabajador, declaro haber recibido de {{razonPrint}}, quien actúa en calidad de empleador la suma de $ {{montoPrint}}, sin intereses.</h6>
                          
        </div>
            </div> <div class="col-sm-1"></div>
        </div>
        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div style="text-align: justify">
                           <h6>Por lo anterior, autorizo a {{razonPrint}} para que realice descuentos de mis remuneraciones de sueldo.</h6>
                          
        </div>
            </div> <div class="col-sm-1"></div>
        </div>

        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div style="text-align: justify">
                         <h6>
                        -Dicho préstamo será descontado en un total de 1 cuota por un valor de ${{montoPrint}} de las liquidaciones haciendo referencia a {{numeroConvenio}}.
                          </h6>
                          
        </div>
            </div> <div class="col-sm-1"></div>
        </div>

        <div class="row">
             <div class="col-sm-1"></div>
            <div class="col-sm-10">
                    <div style="text-align: justify">
                          <h6>
                            -Asimismo, si se diera termino al contrato de trabajo de manera anticipada, autorizo expresamente al empleador a descontar de mi Liquidación de Sueldo y/o Finiquito, los valores que correspondan a saldos adeudados de dicho préstamo.
                          </h6>
        </div>
            </div> <div class="col-sm-1"></div>
        </div><br><br><br>
        <div class="row">
            <div class="col-sm-2"></div>
             <div class="col-sm-3">
                <div class="d-flex justify-content-start">
               <span>
                 .......................................<br>
                 <h6>FIRMA EMPLEADOR</h6><br>
               </span>
              </div>    
             </div>
              
            <div class="col-sm-2"></div> 
            
            <div class="col-sm-3">
                <div class="d-flex justify-content-start">
               <span>
                 .......................................<br>
                 <h6>FIRMA TRABAJADOR</h6><br>
               </span>
              </div> 
            </div>
            <div class="col-sm-2"></div>
        </div>
        


    </div>
</div>
</template>

<script>
import { db } from "../firebaseDb";
import { storage } from "../firebaseDb";
import Swal from "sweetalert2";
import Vue from 'vue'
    import { BootstrapVue } from 'bootstrap-vue'
    import excel from 'vue-excel-export'
    Vue.use(BootstrapVue)
    Vue.use(excel)
const ref = storage.ref();

export default {
  data() {
    return {
      Transacciones: [],
      vendedores:[],
      editado:[],
      chequeEditado:[],
      observacion:'',
      key:'',
      rutFacturacion:'',
      documento:'',
      rut:'',
      nombreTitular:'',
      razonSocial:'',
      monto:'',
      usuario:'',
      largo:'',
      Vales:[],
       fechaPrint:'',
                nombrePrint:'',
                rutPrint:'',
                razonPrint:'',
                montoPrint:'',
                numeroConvenio:'',
      descuentosxPersona:[],
      json_fields: {
            'RUT': 'rut',
            'NOMBRE': 'nombre',
            'PRODUCTO': 'producto',
            'CANTIDAD': 'cantidad',
            'PRECIO': 'precio',
            'TOTAL': 'total',
            'METODO PAGO': 'metodoPago',
            'FECHA': 'fecha',
            'USUARIO': 'usuario',
            'SUCURSAL':'sucursal',
            'SUCURSAL ENTREGA':'sucursalEntrega',
            'CONVENIO':'convenio',
            'RAZON':'razon',
            'OBSERVACION':'observacion',
        },

        json_fieldsDesc: {
            'RUT': 'rut',
            'NOMBRE': 'nombre',
            'SUCURSAL': 'sucursal',
            'AREA': 'area',
            'RAZÓN': 'razon',
            'TOTAL DESC.': 'descuento',
            'CONVENIO 1': 'descuento1',
            'CONVENIO 2': 'descuento2',
        },
        json_meta: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],
    };
  },
  created() {
    document.getElementById("nav").style.display="block";
    this.usuario=localStorage.nombreUsuario;
    this.validarUsuario();
    
   
    
  },
  methods: {
    imprimirComprobante(rut,nombre,razon,convenio,precio,fecha,tipo){
      //console.log(rut,nombre,razon,convenio,precio,fecha)
      var f1=fecha.split(" ")
      var f2=f1[0]
      this.rutPrint=rut;
      this.nombrePrint=nombre;
      this.razonPrint=razon;
      this.montoPrint=precio;
      if(tipo==undefined){
        this.numeroConvenio='CONVENIO BIENESTAR '+convenio;
      }else if(tipo=='PRODUCTO'){
        this.numeroConvenio='CONVENIO BIENESTAR '+convenio;
      }else if(tipo=='ROPA'){
        this.numeroConvenio='ROPA EXTRA';
      }
      
      this.fechaPrint=f2;
      //window.print();
      setTimeout(this.imprimirComp, 1000);
    },
    imprimirComp(){
      window.print();
    },

    verArchivo(imagen) {
      //console.log(imagen);
      document.getElementById("pdf").src = "";
     // console.log(imagen);
      const refImg = ref
        .child("comprobantes/" + imagen)
        .getDownloadURL()
        .then(function (url) {
          console.log(refImg);

          var img = document.getElementById("pdf");
          img.src = url;
        })
        .catch(function (error) {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "No hay imagen asociada",
            icon: "error",
          });
        });
    },
    
    buscarTipoPago(){
       var tipoPago= document.getElementById("tipoPago").value;
       var fecha1= document.getElementById("fecha1v").value;
       var fecha2= document.getElementById("fecha2v").value;
       
                var fecha12=fecha1.split("-");
                var año=fecha12[0]
                var mes=fecha12[1]
                var dia=fecha12[2]
                var fechaF1=año+mes+dia

                var fecha22=fecha2.split("-");
                var año2=fecha22[0]
                var mes2=fecha22[1]
                var dia2=fecha22[2]
                var fechaF2=año2+mes2+dia2
                console.log()
        if(tipoPago!="Todos"){
            db.collection('vale').where("fr", ">=", fechaF1).where("fr", "<=", fechaF2).where("metodoPago", "==", tipoPago).orderBy("fr","desc").orderBy("hora","desc").onSnapshot((snapshotChange) => {
                this.Vales = [];
                if(snapshotChange.empty){
                  Swal.fire({
                      title: "Error",
                      text: "No se encontraron vales",
                      icon: "error",
                    });
                }else{
                  
                    this.largo=(snapshotChange.docs.length)
                    snapshotChange.forEach((doc) => {
                      if(doc.data().tipo==undefined){
                         var imagen=(doc.data().imagen?doc.data().imagen:"no")
                        this.Vales.push({
                          key: doc.id,
                          producto: doc.data().producto,
                          cantidad: doc.data().cantidad,
                          precio: doc.data().precio,
                          total: doc.data().total,
                          rut: doc.data().rut,
                          nombre: doc.data().nombre,
                          razon: doc.data().razon,
                          observacion: doc.data().observacion, 
                          metodoPago: doc.data().metodoPago,
                          usuario: doc.data().usuario,
                          fecha: doc.data().fecha+" "+doc.data().hora,
                          sucursal: doc.data().sucursal,
                          sucursalEntrega: doc.data().sucursalEntrega,
                          convenio:'CONVENIO 1',
                          comprobante:imagen,
                          tipo:doc.data().tipo,
                        })

                      }else{
                        var imagen2=(doc.data().imagen?doc.data().imagen:"no")
                        this.Vales.push({
                          key: doc.id,
                          producto: doc.data().producto,
                          cantidad: doc.data().cantidad,
                          precio: doc.data().precio,
                          total: doc.data().total,
                          rut: doc.data().rut,
                          nombre: doc.data().nombre,
                          razon: doc.data().razon,
                          observacion: doc.data().observacion, 
                          metodoPago: doc.data().metodoPago,
                          usuario: doc.data().usuario,
                          fecha: doc.data().fecha+" "+doc.data().hora,
                          sucursal: doc.data().sucursal,
                          sucursalEntrega: doc.data().sucursalEntrega,
                          convenio:'CONVENIO 2',
                          comprobante:imagen2,
                          tipo:doc.data().tipo,
                        })
                      }
                      
                       
                });
                }
               
          })
        }else{
            db.collection('vale').where("fr", ">=", fechaF1).where("fr", "<=", fechaF2).orderBy("fr","desc").orderBy("hora","desc").onSnapshot((snapshotChange) => {
                this.Vales = [];
                if(snapshotChange.empty){
                  Swal.fire({
                      title: "Error",
                      text: "No se encontraron vales",
                      icon: "error",
                    });
                }else{
                    this.largo=(snapshotChange.docs.length)
                    snapshotChange.forEach((doc) => {
                       if(doc.data().tipo==undefined){
                           var imagen=(doc.data().imagen?doc.data().imagen:"no")
                        this.Vales.push({
                          key: doc.id,
                          producto: doc.data().producto,
                          cantidad: doc.data().cantidad,
                          precio: doc.data().precio,
                          total: doc.data().total,
                          rut: doc.data().rut,
                          nombre: doc.data().nombre,
                          razon: doc.data().razon,
                          observacion: doc.data().observacion, 
                          metodoPago: doc.data().metodoPago,
                          usuario: doc.data().usuario,
                          fecha: doc.data().fecha+" "+doc.data().hora,
                          sucursal: doc.data().sucursal,
                          sucursalEntrega: doc.data().sucursalEntrega,
                          convenio:'CONVENIO 1',
                          comprobante:imagen,
                          tipo:doc.data().tipo,
                        })

                       }else{
                           var imagen2=(doc.data().imagen?doc.data().imagen:"no")
                        this.Vales.push({
                          key: doc.id,
                          producto: doc.data().producto,
                          cantidad: doc.data().cantidad,
                          precio: doc.data().precio,
                          total: doc.data().total,
                          rut: doc.data().rut,
                          nombre: doc.data().nombre,
                          razon: doc.data().razon,
                          observacion: doc.data().observacion, 
                          metodoPago: doc.data().metodoPago,
                          usuario: doc.data().usuario,
                          fecha: doc.data().fecha+" "+doc.data().hora,
                          sucursal: doc.data().sucursal,
                          sucursalEntrega: doc.data().sucursalEntrega,
                          convenio:'CONVENIO 2',
                          comprobante:imagen2,
                          tipo:doc.data().tipo,
                        })
                       }

                       
                });
                }
               
          })
        }      
        
    },
    buscarDescuentosPersona(){
      //var tipo=document.getElementById("conveniorrhh").value;
      //var tipoConvenio=(tipo=="2")?"PRODUCTO":undefined;
      var fecha1=document.getElementById("fecha1rrhh").value;
      var fecha2=document.getElementById("fecha2rrhh").value;

       var fecha12=fecha1.split("-");
                var año=fecha12[0]
                var mes=fecha12[1]
                var dia=fecha12[2]
                var fechaF1=año+mes+dia

                var fecha22=fecha2.split("-");
                var año2=fecha22[0]
                var mes2=fecha22[1]
                var dia2=fecha22[2]
                var fechaF2=año2+mes2+dia2

         db.collection('colaborador').orderBy("nombre","asc").onSnapshot((snapshotChange) => {
                this.descuentosxPersona = [];
                if(snapshotChange.empty){
                  Swal.fire({
                      title: "Error",
                      text: "No se encontraron datos",
                      icon: "error",
                    });
                }else{
                    snapshotChange.forEach((doc) => {
                    //  if(doc.data().cupodisponible<doc.data().cupo){
                       // console.log(doc.data())

                        db.collection('vale').where("fr", ">=", fechaF1).where("fr", "<=", fechaF2).where("rut", "==", doc.data().rut).where("metodoPago", "==", "Desc. Planilla").orderBy("fr","desc").orderBy("nombre","asc").onSnapshot((snapshotChange) => {
                                  
                                  //console.log(snapshotChange.docs.length)
                                   if(snapshotChange.docs.length==1){
                                    let diff1=0
                                    let diff2=0
                                    if(snapshotChange.docs[0].data().tipo){
                                      diff2=snapshotChange.docs[0].data().total
                                    }else{
                                      diff1=snapshotChange.docs[0].data().total
                                    }
                                    console.log(snapshotChange.docs[0].data())
                                      this.descuentosxPersona.push({
                                      rut: doc.data().rut,
                                      nombre: doc.data().nombre,
                                      sucursal: doc.data().sucursal,
                                      area: doc.data().area,
                                      razon: doc.data().razon,
                                      rutrazon: doc.data().rutrazon,
                                      descuento:snapshotChange.docs[0].data().total,
                                      descuento1:diff1,
                                      descuento2:diff2,
                                      convenio:snapshotChange.docs[0].data().tipo
                                      })
                                    
                                   }else{
                                    let largo=snapshotChange.docs.length
                                    let indice=0
                                    //let arreglo={}
                                    let dif=0
                                    let dif1=0
                                    let dif2=0
                                    snapshotChange.forEach((doc) => {
                                     console.log(doc.data())
                                     indice=parseInt(indice)+parseInt(1)
                                     if(largo==indice){

                                      dif=parseInt(dif)+parseInt(doc.data().total)
                                      console.log('listo')
                                      if(doc.data().tipo){
                                         dif2=parseInt(dif2)+parseInt(doc.data().total)
                                      }else{
                                         dif1=parseInt(dif1)+parseInt(doc.data().total)
                                      }
                                        this.descuentosxPersona.push({
                                          rut: doc.data().rut,
                                          nombre: doc.data().nombre,
                                          sucursal: doc.data().sucursal,
                                          area: doc.data().area,
                                          razon: doc.data().razon,
                                          rutrazon: doc.data().rutrazon,
                                          descuento:dif,
                                          descuento1:dif1,
                                          descuento2:dif2,
                                          convenio:snapshotChange.docs[0].data().tipo
                                          
                                      })
                                      
                                     }else{
                                      console.log('no')
                                      dif=parseInt(dif)+parseInt(doc.data().total)
                                      if(doc.data().tipo){
                                         dif2=parseInt(dif2)+parseInt(doc.data().total)
                                      }else{
                                         dif1=parseInt(dif1)+parseInt(doc.data().total)
                                      }
                                     }
                                    })
                                   }
                                   /*snapshotChange.forEach((doc) => {
                                     console.log(doc.data())
                                      
                                    });*/

                                
                        }) 




                     // }
                    
                    });
                }
               
          })
    },



    buscarDescuentosPersona11(){
      
         db.collection('colaborador').orderBy("nombre","asc").onSnapshot((snapshotChange) => {
                this.descuentosxPersona = [];
                if(snapshotChange.empty){
                  Swal.fire({
                      title: "Error",
                      text: "No se encontraron datos",
                      icon: "error",
                    });
                }else{
                   
                    snapshotChange.forEach((doc) => {
                    if(doc.data().cupodisponible<doc.data().cupo){
                    //var dif=parseInt(doc.data().cupo)-parseInt(doc.data().cupodisponible)
                      //console.log(dif)
                      this.sum=0
                      this.largoSum=0
                      //var docRef = db.collection('vale').where("rut", "==", doc.data().rut).where("metodoPago", "==", "Desc. Planilla");
            db.collection('vale').where("rut", "==", doc.data().rut).where("metodoPago", "==", "Desc. Planilla").get().then((querySnapshot) => {
                  //docRef.get().then((x) => {
                  //var largo=(doc.docs.length)
                      //db.collection('vale').where("rut", "==", doc.data().rut).where("metodoPago", "==", "Desc. Planilla").onSnapshot((snapshotChange) => {
                          //console.log(snapshotChange)
                              console.log(querySnapshot.docs.length,this.sum)
                              this.largoSum=querySnapshot.docs.length
                              //var data=x.docs
                              querySnapshot.docs.forEach((doc) => {
                                  //console.log(doc)
                                  //console.log(this.largoSum,this.sum)
                                    if(this.largoSum>this.sum){
                                      console.log("si")
                                      var dif=parseInt(doc.data().cupo)-parseInt(doc.data().cupodisponible)
                                      this.descuentosxPersona.push({
                                      rut: doc.data().rut,
                                      nombre: doc.data().nombre,
                                      sucursal: doc.data().sucursal,
                                      area: doc.data().area,
                                      razon: doc.data().razon,
                                      rutrazon: doc.data().rutrazon,
                                      descuento:dif
                                
                                      })
                                      this.sum=parseInt(this.sum)+parseInt(1)
                                    }
                                    
                                
                              
                          });
                          
               
          })
                      
                      
                      /*
                      this.descuentosxPersona.push({
                        rut: doc.data().rut,
                        nombre: doc.data().nombre,
                        sucursal: doc.data().sucursal,
                        area: doc.data().area,
                        razon: doc.data().razon,
                        rutrazon: doc.data().rutrazon,
                        descuento:dif
                       
                    })*/
                    }
                    
                });
                }
               
          })
    },

    buscarDescuentosPersona1(){
      
         db.collection('colaborador').orderBy("nombre","asc").onSnapshot((snapshotChange) => {
                this.descuentosxPersona = [];
                if(snapshotChange.empty){
                  Swal.fire({
                      title: "Error",
                      text: "No se encontraron datos",
                      icon: "error",
                    });
                }else{
                   
                    snapshotChange.forEach((doc) => {
                    if(doc.data().cupodisponible<doc.data().cupo){
                      var dif=parseInt(doc.data().cupo)-parseInt(doc.data().cupodisponible)
                      this.descuentosxPersona.push({
                        rut: doc.data().rut,
                        nombre: doc.data().nombre,
                        sucursal: doc.data().sucursal,
                        area: doc.data().area,
                        razon: doc.data().razon,
                        rutrazon: doc.data().rutrazon,
                        descuento:dif
                       
                    })
                    }
                    
                });
                }
               
          })
    },


    buscarRut(){
       var rut= document.getElementById("rut").value.toUpperCase().replaceAll(".","");
       var fecha1= document.getElementById("fecha1RUT").value;
       var fecha2= document.getElementById("fecha2RUT").value;
       
                var fecha12=fecha1.split("-");
                var año=fecha12[0]
                var mes=fecha12[1]
                var dia=fecha12[2]
                var fechaF1=año+mes+dia;

                var fecha22=fecha2.split("-");
                var año2=fecha22[0]
                var mes2=fecha22[1]
                var dia2=fecha22[2]
                var fechaF2=año2+mes2+dia2;
         db.collection('vale').where("fr", ">=", fechaF1).where("fr", "<=", fechaF2).where("rut", "==", rut).orderBy("fr","desc").orderBy("hora","desc").onSnapshot((snapshotChange) => {
                this.Vales = [];
                if(snapshotChange.empty){
                  Swal.fire({
                      title: "Error",
                      text: "No se encontraron vales",
                      icon: "error",
                    });
                }else{
                    this.largo=(snapshotChange.docs.length)
                    snapshotChange.forEach((doc) => {
                      var imagen=(doc.data().imagen?doc.data().imagen:"no")
                    this.Vales.push({
                        key: doc.id,
                        producto: doc.data().producto,
                        cantidad: doc.data().cantidad,
                        precio: doc.data().precio,
                        total: doc.data().total,
                        rut: doc.data().rut,
                        nombre: doc.data().nombre,
                        razon: doc.data().razon,
                        observacion: doc.data().observacion, 
                        metodoPago: doc.data().metodoPago,
                        usuario: doc.data().usuario,
                        fecha: doc.data().fecha+" "+doc.data().hora,
                        comprobante:imagen
                    })
                });
                }
               
          })
    },
    
    validarUsuario(){
            if(this.usuario==undefined || this.usuario=="X"){
                this.$router.push('/')
            }
        },

    leer(){
                var rut = document.getElementById("rut").value;
				var rutx=rut.replace("-","");
				var largo=rutx.length
				//console.log(largo,largo-1)
				var rut2=rutx.slice(0,largo-1)
				var rut3=rutx.slice(largo-1)
                //console.log(rut2+"-"+rut3)
				document.getElementById("rut").value=(rut2+"-"+rut3)
				
        },
      irMenu(){
                if(localStorage.tipoUsuario=="1"){
                    this.$router.push('/menu')
                }else if(localStorage.tipoUsuario=="2" || localStorage.tipoUsuario=="3"){
                    this.$router.push('/menutransportes')
                }
            },

        cambio(){
     var busqueda=document.getElementById("busqueda").value;
      this.largo='';
      console.log(busqueda)
      if(busqueda=="1"){
        this.Vales=[];
        document.getElementById('pdf').src="";
          document.getElementById("btipopago").style.display="block"; 
          document.getElementById("brut").style.display="none";
          document.getElementById("bdesc").style.display="none";
          document.getElementById("tablaDesc").style.display="none"; 
          document.getElementById("btnExcel1").style.display="block"; 
          document.getElementById("btnExcel2").style.display="none";
          document.getElementById("tablaVales").style.display="block"; 
          
      }else if(busqueda=="2"){
        this.Vales=[];
        document.getElementById('pdf').src="";
        document.getElementById("btipopago").style.display="block"; 
          document.getElementById("brut").style.display="none";
          document.getElementById("bdesc").style.display="none";
          document.getElementById("tablaDesc").style.display="none"; 
          document.getElementById("btnExcel1").style.display="block"; 
          document.getElementById("btnExcel2").style.display="none";
          document.getElementById("tablaVales").style.display="block"; 
          document.getElementById("brrhh").style.display="none"; 
      }else if(busqueda=="3"){
        this.Vales=[];
        document.getElementById('pdf').src="";
        document.getElementById("btipopago").style.display="none"; 
        document.getElementById("tablaVales").style.display="block"; 
        document.getElementById("brut").style.display="block";
        document.getElementById("brrhh").style.display="none"; 
        document.getElementById("bdesc").style.display="none";
        document.getElementById("tablaDesc").style.display="none";
        //this.buscarDescuentosPersona()
        document.getElementById("btnExcel1").style.display="none"; 
        document.getElementById("btnExcel2").style.display="none"; 
          
      }else if(busqueda=="4"){
        this.Vales=[];
        document.getElementById('pdf').src="";
        document.getElementById("btipopago").style.display="none"; 
        document.getElementById("tablaVales").style.display="none"; 
        document.getElementById("brut").style.display="none";
        document.getElementById("brrhh").style.display="block"; 
        document.getElementById("bdesc").style.display="block";
        document.getElementById("tablaDesc").style.display="block";
        //this.buscarDescuentosPersona()
        document.getElementById("btnExcel1").style.display="none"; 
        document.getElementById("btnExcel2").style.display="block";
      }

    },
    
  },
};
</script>

<style>
.btn-primary {
  margin-right: 12px;
}
</style>